var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Array.isArray(_vm.field))?_c('prismic-rich-text',{class:_vm.className,attrs:{"field":_vm.field}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }